var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Unqualified"}},[_c('h6',[_vm._v("You are already employed!")])])}
var staticRenderFns = []

export { render, staticRenderFns }